// extracted by mini-css-extract-plugin
module.exports = {"Steps":"Steps_Steps__1I6KO","Title":"Steps_Title__A0vSF"};